import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';

interface TripDndChangeTimeDialogProbs {
  currentDate?: Date;
  tripIndex: number;
  // eslint-disable-next-line
  onSetDate?: (tripIndex: number, date: string) => void;
  onClose?: () => void;
}
export function TripDndChangeTimeDialog({ tripIndex, currentDate, onSetDate, onClose }: TripDndChangeTimeDialogProbs) {
  const [newTime, setNewTime] = useState(moment(currentDate).format('HH:mm'));
  const [newDate, setNewDate] = useState(moment(currentDate).format('YYYY-MM-DD'));
  useEffect(() => {
    setNewTime(moment(currentDate).format('HH:mm'));
    setNewDate(moment(currentDate).format('YYYY-MM-DD'));
  }, [tripIndex, currentDate]);
  return (
    <Dialog
      open={tripIndex >= 0}
      onClose={() => {
        onClose && onClose();
      }}
    >
      <DialogTitle>
        <Grid container alignItems="center">
          Change Trip Start Time
        </Grid>
      </DialogTitle>
      <DialogContent>
        <TextField
          type="date"
          variant="standard"
          value={newDate}
          title="New Date"
          onChange={(e) => {
            setNewDate(e.target.value);
          }}
          fullWidth
        />
        <TextField
          type="time"
          variant="standard"
          value={newTime}
          title="New Time"
          onChange={(e) => {
            setNewTime(e.target.value);
          }}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="end">
          <Button
            onClick={() => {
              if (moment(currentDate).format('YYYY-MM-DD HH:mm:ss') === newDate) {
                onClose && onClose();
              } else {
                onSetDate && onSetDate(tripIndex, `${newDate} ${newTime}:00`);
              }
            }}
          >
            Ok
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
